<script setup lang="ts">
import { useSessionStore } from '@/Stores/AppStore';
import { inject, Ref } from 'vue';

const { variant = 'primary' } = defineProps<{
    variant?: 'primary' | 'secondary'
}>()

const showSupport = inject<Ref<Boolean>>("show-support")

const session = useSessionStore()
</script>

<template>
    <button :class="variant === 'secondary' ? 'btn-secondary' : 'btn-primary'"
        class="px-4! py-2! inline-flex items-center gap-2" @click="showSupport = true">
        <!-- TODO: Find what to call the support chat with the organizers -->
        Supporto tecnico
        <!-- Same news dot as the consultant's conversation cards, in the flow rather than
             pinned to a corner: the callers lay the button out themselves, so the component
             can't claim `relative` for itself. -->
        <span v-if="session.supportUnread" class="size-3 block bg-warning rounded-full"></span>
    </button>
</template>

<style>
@reference "tailwindcss";
@reference "#app.css";
</style>
